var _rect, _path, _rect2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDriverProfile(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 49,
    height: 49,
    rx: 24.5,
    fill: "#E5E7EB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.7135 27.3337C33.1626 27.3337 34.3372 28.5083 34.3372 29.9574V30.6287C34.3372 31.672 33.9643 32.681 33.2859 33.4736C31.455 35.6127 28.6699 36.6683 25.0004 36.6683C21.3302 36.6683 18.5465 35.6123 16.7191 33.4723C16.0427 32.6803 15.6711 31.6728 15.6711 30.6312V29.9574C15.6711 28.5083 16.8458 27.3337 18.2948 27.3337H31.7135ZM31.7135 29.0837H18.2948C17.8123 29.0837 17.4211 29.4748 17.4211 29.9574V30.6312C17.4211 31.2562 17.6441 31.8607 18.0499 32.3359C19.5121 34.0482 21.8057 34.9183 25.0004 34.9183C28.1951 34.9183 30.4906 34.0482 31.9564 32.3356C32.3636 31.86 32.5872 31.2546 32.5872 30.6287V29.9574C32.5872 29.4748 32.196 29.0837 31.7135 29.0837ZM25.0004 13.3391C28.222 13.3391 30.8337 15.9508 30.8337 19.1724C30.8337 22.3941 28.222 25.0058 25.0004 25.0058C21.7787 25.0058 19.167 22.3941 19.167 19.1724C19.167 15.9508 21.7787 13.3391 25.0004 13.3391ZM25.0004 15.0891C22.7452 15.0891 20.917 16.9173 20.917 19.1724C20.917 21.4276 22.7452 23.2558 25.0004 23.2558C27.2555 23.2558 29.0837 21.4276 29.0837 19.1724C29.0837 16.9173 27.2555 15.0891 25.0004 15.0891Z",
    fill: "#7D7D7D"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 49,
    height: 49,
    rx: 24.5,
    stroke: "#FAFAFA"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDriverProfile);
export default __webpack_public_path__ + "static/media/driverProfile.ca85a6526dbb43729a699dd008bd483c.svg";
export { ForwardRef as ReactComponent };